import type { UnknownAction } from '@reduxjs/toolkit'
import { 
  FETCH_ACCOUNT_REQUEST, 
  FETCHING_ACCOUNT_FAILED, 
  FETCHING_ACCOUNT_SUCCEDDED, 
  UPDATE_ACCOUNT_REQUEST,
  UPDATING_ACCOUNT_FAILED,
  UPDATING_ACCOUNT_SUCCEDDED,
  UPDATING_PRIVACY_POLICY_CONTROL,
  UPDATING_PRIVACY_POLICY_CONTROL_FAILED,
  UPDATING_PRIVACY_POLICY_CONTROL_SUCCEEDED
} from '../actions/actionTypes'
import { Account } from '../../types/accounts';

interface AccountState {
  loading: boolean;
  item: Account | null;
  error?: any | null;
  updating: boolean;
  updated?: boolean;
  privacyPolicyControl?: {
    updating: boolean;
    updated: boolean;
    error: any;
  };
}

const initialState: AccountState = {
  loading: false,
  item: null,
  updating: false,
  updated: false,
  privacyPolicyControl: {
    updating: false,
    updated: false,
    error: null
  }
}

export function accountsReducer(state: AccountState = initialState, action: UnknownAction) : AccountState {
  switch (action.type) {
    case FETCH_ACCOUNT_REQUEST: {
      return {
        ...state,
        loading: true,
      }
    }

    case FETCHING_ACCOUNT_SUCCEDDED: {
      const account = action.payload as Account;
      return {
        ...state,
        loading: false,
        item: account,
        error: null
      }
    }

    case FETCHING_ACCOUNT_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        loading: false,
        error: error
      }
    }

    case UPDATE_ACCOUNT_REQUEST: {
      return {
        ...state,
        updating: true,
        updated:false,
      }
    }
    case UPDATING_ACCOUNT_SUCCEDDED:{
      return {
        ...state,
        updating: false,
        updated: true,
        item: action.payload as Account
    }
    }
    case UPDATING_ACCOUNT_FAILED: {
      return {
        ...state,
        updating: false,
        updated: false,
        error: action.payload
      }
    }

    case UPDATING_PRIVACY_POLICY_CONTROL: {
      return {
        ...state,
        privacyPolicyControl: {
          updating: true,
          updated: false,
          error: null
        }
      }
    }

    case UPDATING_PRIVACY_POLICY_CONTROL_SUCCEEDED: {
      return {
        ...state,
        privacyPolicyControl: {
          updating: false,
          updated: true,
          error: null
        }
      }
    }

    case UPDATING_PRIVACY_POLICY_CONTROL_FAILED: {
      return {
        ...state,
        privacyPolicyControl: {
          updating: false,
          updated: false,
          error: action.payload
        }
      }
    }

    default: {
      return state
    }
  }
}